<template>
  <div>
    <h1></h1>
    <v-list>
      <v-list-item>
        <template>
          <v-list-item-action>
            <v-checkbox
              v-model="settings.restricted_zones"
              @change="event => changeDataEdit('restricted_zones', event)"
            ></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Restringir zonas</v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              Si esta activo, el sistema restringira las zonas que se pueden
              seleccionar en el formulario de Leads (Se mostraran los
              desarrollos habilitados para esta inmobiliaria).
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-list-item>
    </v-list>
  </div>
</template>
<script>
import { mapActions } from "vuex";
const DEFAULT_VALUES = {
  restricted_zones: false
};

export default {
  name: "SettingsInmo",
  props: {
    realEstateGroupId: {
      type: String,
      required: true
    },
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      settings: {}
    };
  },
  created() {
    this.settings = { ...DEFAULT_VALUES, ...this.values };
  },
  methods: {
    ...mapActions("root", ["updateInmoSettings"]),
    changeDataEdit(key, event) {
      this.settings[key] = event;
      this.updateInmoSettings({
        inmoId: this.realEstateGroupId,
        settings: { ...this.settings }
      });
    }
  }
};
</script>
